export default {
  large: {
    height: '32px',
    maxWidth: undefined,
    size: '21px'
  },
  medium: {
    height: '24px',
    maxWidth: undefined,
    size: '16px'
  },
  small: {
    height: '16px',
    maxWidth: undefined,
    size: '12px'
  },
  xlarge: {
    height: '21px',
    maxWidth: undefined,
    size: '17px'
  },
  xxlarge: {
    height: '27px',
    maxWidth: undefined,
    size: '23px'
  }
}
